import { Controller } from "@hotwired/stimulus";
import NotificationsSubscription from "../../channels/notifications_subscription";

export default class extends Controller {
  static identifier: string;

  static setIdentifier(identifier: string) {
    this.identifier = identifier;
  }

  static values = {
    currentUserId: Number,
    initialCount: Number,
    inboxId: String,
  };

  static targets = ["badge", "count"];

  declare readonly currentUserIdValue: number;
  declare readonly initialCountValue: number;
  declare readonly hasInboxIdValue: boolean;
  declare readonly inboxIdValue: string;
  declare readonly hasBadgeTarget: boolean;
  declare readonly badgeTarget: HTMLElement;
  declare readonly hasCountTarget: boolean;
  declare readonly countTarget: HTMLElement;

  private notificationsSubscription!: NotificationsSubscription;
  private unreadCount: number = 0;
  private boundCallback: ((data: any) => void) | null = null;

  connect() {
    console.log("Unread badge controller connected");
    this.unreadCount = this.initialCountValue || 0;
    this.subscribeToChannel();
  }

  disconnect() {
    if (this.boundCallback && this.notificationsSubscription) {
      this.notificationsSubscription.removeCallback(this.boundCallback);
    }
  }

  subscribeToChannel() {
    this.notificationsSubscription = NotificationsSubscription.getInstance();

    this.boundCallback = (data: any): void => {
      console.log("Unread badge received data:", data);

      if (data.message) {
        this.handleNewMessage(data.message);
      } else if (data.unread_count_update) {
        this.updateCount(data.unread_count_update.count);
      } else if (data.unread_counts) {
        this.handleUnreadCountsUpdate(data.unread_counts);
      }
    };

    this.notificationsSubscription.addCallback(this.boundCallback);
  }

  handleNewMessage(message: any) {
    // Don't do client-side increments anymore
    // The server will send updated unread_counts with the message broadcast
    // This prevents race conditions and ensures accuracy
  }

  handleUnreadCountsUpdate(unreadCounts: any) {
    // Update count based on whether this badge is for a specific inbox or total
    if (this.hasInboxIdValue && unreadCounts[this.inboxIdValue] !== undefined) {
      // This badge is for a specific inbox
      this.updateCount(unreadCounts[this.inboxIdValue]);
    } else if (!this.hasInboxIdValue && unreadCounts.total !== undefined) {
      // This badge is for "All Conversations" - use total count
      this.updateCount(unreadCounts.total);
    }
  }

  incrementCount() {
    this.unreadCount++;
    this.updateBadgeDisplay();
  }

  updateCount(count: number) {
    this.unreadCount = count;
    this.updateBadgeDisplay();
  }

  updateBadgeDisplay() {
    if (this.unreadCount > 0) {
      // Show badge
      if (this.hasBadgeTarget) {
        this.badgeTarget.classList.remove("hidden");
      }

      // Update count text
      if (this.hasCountTarget) {
        this.countTarget.textContent = this.unreadCount.toString();
      }
    } else {
      // Hide badge
      if (this.hasBadgeTarget) {
        this.badgeTarget.classList.add("hidden");
      }
    }
  }
}
